import React, { createContext, useContext } from "react";
import { useStores } from "#stores";
import * as amplitude from "@amplitude/analytics-browser";
import { EventData, EventName } from "./event-types";

interface AnalyticsContextData {
	sendEvent<T extends EventName>(eventName: T, eventData: EventData<T>): void;
}

const AnalyticsContext = createContext({} as AnalyticsContextData);

export function AnalyticsProvider({ children }: { children: React.ReactNode }) {
	const { authStore } = useStores();
	const user = authStore.currentEmployee;

	if (user?.id) {
		amplitude.setUserId(user.id);
		amplitude.setGroup("organizationId", user.organization.id);

		const identify = new amplitude.Identify();
		identify.set("isZigpayEmployee,", authStore.isZigpayEmployee);
		amplitude.identify(identify);
	}

	const sendEvent = <T extends EventName>(eventName: T, eventData: EventData<T>) => {
		amplitude.track(eventName, eventData);
	};

	return (
		<AnalyticsContext.Provider value={{ sendEvent }}>
			{children}
		</AnalyticsContext.Provider>
	);
}

export function useAnalytics() {
	return useContext(AnalyticsContext);
}
